import { render, staticRenderFns } from "./PublisherEditor.vue?vue&type=template&id=78bc4b2b&scoped=true"
import script from "./PublisherEditor.vue?vue&type=script&lang=js"
export * from "./PublisherEditor.vue?vue&type=script&lang=js"
import style0 from "./PublisherEditor.vue?vue&type=style&index=0&id=78bc4b2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bc4b2b",
  null
  
)

export default component.exports